import { z } from 'zod';
import { AuditEntryCategory } from '../enums/audits.js';

export * from './agents.js';
export * from './accounts.js';
export * from './account-features.js';
export * from './applications.js';
export * from './application-features.js';
export * from './auth-apps.js';
export * from './data-sources.js';
export * from './agent-data-sources.js';
export * from './agent-data-connection-queries.js';
export * from './compliance.js';
export * from './search.js';
export * from './crm-connections.js';
export * from './data-connection-features.js';
export * from './form-schemas.js';
export * from './form-workflows.js';
export * from './pages.js';
export * from './prompts.js';
export * from './product-brands.js';
export * from './drug-classes.js';
export * from './terminology.js';
export * from './generic-drugs.js';
export * from './indications.js';
export * from './therapeutic-areas.js';
export * from './territories.js';
export * from './workspace-migration.js';

export namespace SearchAudits {
  export const RequestBodySchema = z.object({
    userIds: z.array(z.coerce.number()).optional(),
    groupIds: z.array(z.coerce.number()).optional(),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    page: z.coerce.number().prefault(1),
    pageSize: z.coerce.number().prefault(100),
    categoryTypes: z.array(z.enum(AuditEntryCategory)).optional(),
  });

  export const ResponseSchema = z.object({
    audits: z.array(
      z.object({
        id: z.number(),
        user: z
          .object({
            id: z.number(),
            name: z.string(),
          })
          .nullable(),
        categoryType: z.enum(AuditEntryCategory),
        categoryData: z.record(z.string(), z.any()),
        createdOn: z.coerce.date(),
        contextData: z.object({
          ip: z.string().optional(),
          userAgent: z.string().optional(),
        }),
        code: z.enum(['success', 'failed']),
      })
    ),
    total: z.number(),
  });
  export type RequestBody = z.infer<typeof RequestBodySchema>;
  export type Response = z.infer<typeof ResponseSchema>;
}
